import React from 'react'
import { CategoryModalFragment } from '#src/generated/graphql'
import CategoryModalContent from '../CategoryModalContent'
import styles from './styles.css'

interface V1Props {
  category: CategoryModalFragment
  brandName: string
  pathUrl: string
}

const V1: React.SFC<V1Props> = ({ category, brandName, pathUrl }) => {
  switch (category.slug) {
    case 'golf-clubs':
    case 'golf-bags':
    case 'golf-gloves':
    case 'golf-balls':
    case 'golf-rangefinders':
    case 'golf-tees':
      return (
        <CategoryModalContent
          headline={
            <>
              <span className={styles.capitalize}>{category.pluralDisplayName}</span> are expensive
              - is this {brandName} right for you?
            </>
          }
          smallHeadline={'Chat with a golf expert and confirm'}
          buttonText={'Shop with an expert'}
          pathUrl={pathUrl}
        />
      )

    case 'electric-bikes':
    case 'mountain-bikes':
    case 'bike-helmets':
    case 'bike-locks':
    case 'bike-pumps':
    case 'bike-tire-repair':
    case 'bike-mirrors':
    case 'bike-cleats':
    case 'bike-frames':
    case 'bike-pedals':
      return (
        <CategoryModalContent
          headline={
            <>
              <span className={styles.capitalize}>{category.pluralDisplayName}</span> are expensive
              - is this brandName right for you?
            </>
          }
          smallHeadline={'Chat with a bike expert and confirm'}
          buttonText={'Shop with an expert'}
          pathUrl={pathUrl}
        />
      )

    case 'skis':
    case 'ski-boots':
    case 'ski-bindings':
    case 'ski-poles':
      return (
        <CategoryModalContent
          headline={
            <>
              <span className={styles.capitalize}>{category.pluralDisplayName}</span> are expensive
              - is this {brandName} right for you?
            </>
          }
          smallHeadline={'Chat with a ski expert and confirm'}
          buttonText={'Shop with an expert'}
          pathUrl={pathUrl}
        />
      )

    case 'snowboards':
    case 'snowboard-boots':
    case 'snowboard-bindings':
      return (
        <CategoryModalContent
          headline={
            <>
              <span className={styles.capitalize}>{category.pluralDisplayName}</span> are expensive
              - is this {brandName} right for you?
            </>
          }
          smallHeadline={'Chat with a snowboard expert and confirm'}
          buttonText={'Shop with an expert'}
          pathUrl={pathUrl}
        />
      )

    case 'winter-sports-jackets':
    case 'winter-sports-gloves':
    case 'winter-sports-pants':
      return (
        <CategoryModalContent
          headline={
            <>
              <span className={styles.capitalize}>{category.pluralDisplayName}</span> are expensive
              - is this {brandName} right for you?
            </>
          }
          smallHeadline={'Chat with a winter sports expert and confirm'}
          buttonText={'Shop with an expert'}
          pathUrl={pathUrl}
        />
      )

    case 'wedding-rings':
    case 'engagement-rings':
    case 'diamonds':
      return (
        <CategoryModalContent
          headline={
            <>
              <span className={styles.capitalize}>{category.pluralDisplayName}</span> are expensive
              - is this one right for you?
            </>
          }
          smallHeadline={'Chat with a jewelry expert and confirm'}
          buttonText={'Shop with an expert'}
          pathUrl={pathUrl}
        />
      )

    default:
      return (
        <CategoryModalContent
          headline={'This looks expensive - want to confirm it’s the best before you buy it?'}
          smallHeadline={'Chat with an expert and confirm'}
          buttonText={'Shop with an expert'}
          pathUrl={pathUrl}
        />
      )
  }
}

export default V1
